/** 加入方倒數結束後，等待房主 Create + SendGameRoomID 的最長秒數 */
export const GUEST_WAIT_ROOM_SECONDS = 20;

let waitForCreatorSeconds = 0;
let timeoutAlertShown = false;

export function resetCountdownWaitCounter() {
  waitForCreatorSeconds = 0;
  timeoutAlertShown = false;
}

export function incrementCountdownWait(): number {
  waitForCreatorSeconds += 1;
  return waitForCreatorSeconds;
}

export function shouldShowCountdownTimeoutAlert(): boolean {
  if (timeoutAlertShown) return false;
  timeoutAlertShown = true;
  return true;
}
